import { Link } from 'react-router';

export default function CommissionDisclaimer() {
  return (
    <div className="flex h-9 w-full items-center justify-center gap-1 bg-dark-background text-center text-xs tracking-wide text-grey-hide">
      <span>We may earn commission when you buy from our links.</span>
      <Link className="underline" to="/about#editorial-policy">
        Info
      </Link>
    </div>
  );
}
